import React from 'react';
import Boom from './boom';
import Clear from './clear';
import Version from './version';

const MetaIndex: React.FC = ({ children }) => <>{children}</>;

export { MetaIndex, Boom, Clear, Version };

export default MetaIndex;
